<template>
	<Row class="flex-align-center flex-justify-space-between">
		<Row class="flex-align-center">
			<h5>Default personal visibility</h5>
			<AppTooltip position="top" text="When off, users won’t be able to<br />use this feature until they turn it on.">
				<SIcon class="info-icon" name="installation-tab-info" width="12" height="14" />
			</AppTooltip>
			<FeatureVisibilityDropdown
				class="ml-3"
				allowLockVisibility
				:isLocked="isLocked"
				showStateInActivator
				:isVisible="isVisible"
				@set-hidden="setHidden"
				@set-visible="setVisible"
				@set-visible-locked="setVisibleLocked"
			/>
		</Row>
		<h3 v-if="showEditFeatureDescriptionLink" @click="$emit('edit-feature-description')" class="reg link edit-description">
			Edit feature description
		</h3>
	</Row>
</template>
<script>
import FeatureVisibilityDropdown from '@/components/FeatureVisibility/FeatureVisibilityDropdown.vue';
export default {
	name: 'ShareDefaultPersonalVisibility',
	components: {
		FeatureVisibilityDropdown,
	},
	props: {
		isLocked: { type: Boolean },
		isVisible: { type: Boolean },
		showEditFeatureDescriptionLink: { type: Boolean },
	},
	methods: {
		setVisible() {
			this.$emit('update:isLocked', false);
			this.$emit('update:isVisible', true);
		},
		setHidden() {
			this.$emit('update:isLocked', false);
			this.$emit('update:isVisible', false);
		},
		setVisibleLocked() {
			this.$emit('update:isLocked', true);
			this.$emit('update:isVisible', true);
		},
	},
};
</script>
<style scoped lang="scss">
.info-icon {
	margin-left: 2px;
	margin-top: -10px;
}

.edit-description {
	color: #949394;
}
</style>
